<mat-dialog-content role="main">
  <h3 class="warningText" style="font-size: 20pt; color: darkred;padding-bottom:10px;">
    <span *ngIf="enforceRule=='warning' || enforceRule=='conflict_warning'" translate>WARNING</span>
    <span *ngIf="enforceRule!='warning' && enforceRule!='conflict_warning'" translate>Error</span>
  </h3>
  <div class="warningText" translate style="padding-bottom: 10px;">
    {{errorTitle}}
  </div>

  <div class="warningText">
    <ul>
      <li *ngFor="let error of errorList">
        &bull; &nbsp;<span *ngIf="error.fieldName!=''">
          {{error.fieldName}} : {{error.errorMsg}}
        </span>
        <span *ngIf="error.fieldName==''">
          {{error.errorMsg}}
        </span>
      </li>
    </ul>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-left">
  </div>
  <div class="flex-footer-right">
    <tyl-button *ngIf="enforceRule=='conflict_warning'" image="Cancel.png" label="Close" (clickEvent)="saveAnywayClick()"></tyl-button>
    <tyl-button *ngIf="enforceRule=='warning'" image="save black.png" label="Save Anyway" (clickEvent)="saveAnywayClick()"></tyl-button>
    <tyl-button *ngIf="enforceRule!=='conflict_warning'" image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
